export const ROOT = '/';
export const NOT_FOUND = '/not_found';
export const CODE = '/icode/*';
export const DESIGN = '/idesign/*';
export const MUSIC = '/imusic/*';
export const CODE_PROJECT = CODE + '/:projectId';
export const DESIGN_PROJECT = DESIGN + '/:projectId';
